module.exports = __webpack_public_path__ + "components/country-flag/static/ic-708eb1a60387ae866b987a6801d51d60.svg";